import React from 'react';
import ReactDOM from 'react-dom/client';
import App from "./App"
import "./App.css"

import { HashRouter } from 'react-router-dom';
import { HelmetProvider } from "react-helmet-async";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <HelmetProvider>
        <React.StrictMode>
            <HashRouter>
                <App />
            </HashRouter>
        </React.StrictMode>
    </HelmetProvider>

);

